/**
 * External dependencies
 */
import { some } from 'lodash';

/**
 * Internal dependencies
 */
import getConnectionSalesType from './get-connection-sales-type';
import getEdits from './get-edits';

export default (state, salesTypeId) => {
    const connectionSalesTypes = getConnectionSalesType(state, salesTypeId);
    const edits = getEdits(state, salesTypeId);

    if (!edits) {
        return false;
    }
   
    if (!connectionSalesTypes && edits) {
        return true;
    }

    if (!connectionSalesTypes) {
        return false;
    }

    const editsDirty = some(edits, (value, key) => {
        return connectionSalesTypes[key] !== value;
    });

    return editsDirty;
};